import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './StorageIndicator.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function StorageIndicator() {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth();

  useEffect(() => {
    fetchUserInfo();
  }, [token]);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${API_URL}/api/v1/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUserInfo(data);
      }
    } catch (error) {
      console.error('Failed to fetch user info:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !userInfo) {
    return null;
  }

  const storageUsedMB = (userInfo.storage_used_bytes / (1024 * 1024)).toFixed(2);
  const storageLimitMB = userInfo.storage_limit_mb;
  const percentageUsed = ((userInfo.storage_used_bytes / (storageLimitMB * 1024 * 1024)) * 100).toFixed(1);
  const isNearLimit = percentageUsed > 80;
  const isDemoAccount = userInfo.account_type === 'temporary';

  return (
    <div className={`storage-indicator ${isNearLimit ? 'warning' : ''}`}>
      <div className="storage-header">
        <span className="storage-label">Storage</span>
        {isDemoAccount && userInfo.expires_at && (
          <span className="demo-badge">Demo</span>
        )}
      </div>
      <div className="storage-details">
        <span className="storage-used">{storageUsedMB}MB</span>
        <span className="storage-separator">/</span>
        <span className="storage-limit">{storageLimitMB}MB</span>
        <span className="storage-percentage">({percentageUsed}%)</span>
      </div>
      <div className="storage-bar">
        <div
          className={`storage-fill ${isNearLimit ? 'warning' : ''}`}
          style={{ width: `${Math.min(percentageUsed, 100)}%` }}
        ></div>
      </div>
      {isDemoAccount && userInfo.expires_at && (
        <div className="demo-expiry">
          <small>Expires: {new Date(userInfo.expires_at).toLocaleString()}</small>
        </div>
      )}
    </div>
  );
}

export default StorageIndicator;
